import { ReactNode } from "react";
import { Popup } from "components/UI/Popup";
import { BaseButton } from "components/buttons/BaseButton";
import "./styles/DeleteCollectionPopup.scss";

interface IDeleteCollectionPopupProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleDelete: () => void;
  text: ReactNode;
}

export const DeleteCollectionPopup = (
  { isOpen, togglePopup, handleDelete, text }: IDeleteCollectionPopupProps
) => {
  return (
    <Popup
      isOpen={isOpen}
      popupClass="DeleteCollectionPopup"
    >
      {text}
      <BaseButton onClick={handleDelete}>Yes, delete</BaseButton>
      <button onClick={togglePopup}>Cancel</button>
    </Popup >
  );
};
